<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="col col-xs-12">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-book"></i> Site Manager Buddy</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <span class="home-1" [routerLink]="['/dashboard']">
                        <i class="fa fa-home ml-3" style="font-size: 37px;"></i>
                    </span>
                </div>
            </div>
            <!--end header-->

            <div class="row row-replace add-m-b bg-main mt-1 p-3">
                <div class="col-md-4 col-6 col-p">
                    <input type="text" [(ngModel)]="pcCode" placeholder="Search By PC Code" class="form-control">
                </div>
                <div class="col-md-3 col-6 col-p">
                    <button class="btn btn-primary btn-sm" (click)="searchProfitCenter()">Search</button>
                    <!-- <button class="btn btn-danger btn-sm m-l-15">Reset</button> -->
                </div>
                <div class="col-md-6 col-1 top-corner-items col-p"></div>
            </div>

            <div class="row m-t-30">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table">
                            <tr class="bg-primary text-white">
                                <th>Sr No.</th>
                                <th>Site Name</th>
                                <th>Site Address</th>
                                <th>Site Manager Name</th>
                                <th>Sub Segment</th>
                                <th>Budgeted Head Count</th>
                                <th>Actual Headcount</th>
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let item of costCenters;let i = index;">
                                <td>{{i+1}}</td>
                                <td>{{item.site_name}}</td>
                                <td>{{item.address}} {{item.pincode_id}} </td>
                                <td>{{item.name}}</td>
                                <td>{{item.subseg_desc}}</td>
                                <td>{{item.budg_headcount}}</td>
                                <td>{{item.actual_head_count}}</td>
                                <td>
                                  <div class="btn-group btn-group-sm">
                                    <button title="View" class="btn-success" (click)="moveToQuery()"  ><i class="fa fa-comments-o" aria-hidden="true"></i></button>
                                </div>
                                </td>


                            </tr>
                        </table>
                    </div>
                </div>
            </div>





            <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->
